import { useBulkCollectionsFilterShallowStore } from '../../../../../store/bulk-collections-filter-store';
import { UseTokenInfiniteScrollReturn, useTokenInfiniteScroll } from '../../../common/hooks/use-token-infinite-scroll';
import { useBulkCollectionsQueryBase } from './use-bulk-collections-query-base';

export const useBulkCollectionsInfiniteScroll = ({ enabled }: { enabled: boolean }): UseTokenInfiniteScrollReturn => {
  const { balanceType, searchValue } = useBulkCollectionsFilterShallowStore('balanceType', 'searchValue');

  return useTokenInfiniteScroll({
    enabled,
    filterKey: `${searchValue}|${balanceType.join(',')}`,
    useQuery: useBulkCollectionsQueryBase,
  });
};
